"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const md_utils_1 = require("../../../export/md.utils");
const toMarkdown = (element, context) => {
    var _a, _b;
    const file = (_a = element.value) === null || _a === void 0 ? void 0 : _a.file;
    if (!file) {
        return '';
    }
    const url = (0, md_utils_1.getFileUrl)(file, context);
    if (!url) {
        return '';
    }
    const label = ((_b = element.value) === null || _b === void 0 ? void 0 : _b.accessibility) || 'Audio';
    return `[${label}](${url})`;
};
exports.toMarkdown = toMarkdown;
